import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TemplatesComponent } from '../templates/templates.component';
import { ViewComponent } from './view/view.component';

const routes: Routes = [
  {
    path: '', component: TemplatesComponent,
  },

  {
    path: ':idTemplate', component: ViewComponent,
    data: { title: 'Vedi e Modifica Template' },
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TemplatesRoutingModule { }
